<template>
  <div class="task-progress-wrap" ref="task-progress-wrap">
    <div class="progress-bar">
      <div class="item">
        <span class="triangle"></span>
        <span class="time">W52</span>
      </div>
      <div class="daily-log-wrap end">
        <div
          class="item"
          v-for="(item,index) in nowLists"
          :key="index"
          :style="{
            ...item.style
          }"
          :class="[
            item.status === 'finish'?'finish':''
          ]"
        >
          <div class="content" v-if="item.status !=='finish'">
            <span class="txt">
              <div class="task-name">
                {{ item.name }}
              </div>
              <div class="log-time">{{ item.time }}</div>
            </span>
            <span class="icon-line">
              <span class="line-time">{{ item.week }}</span>
            </span>
          </div>
          <div class="content" v-else>
            <span class="icon-line">
              <span class="line-time">{{ item.week }}</span>
            </span>
            <span class="txt">
              <div class="task-name">
                {{ item.name }}
              </div>
              <div class="log-time">{{ item.time }}</div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [
    'lists'
  ],
  data () {
    return {
      itemIndex: 1,
      nowLists: []
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.nowLists = this.getBeginLists()
  },
  watch: {

  },
  methods: {
    getIndex (item) {
      let t = this.$refs['task-progress-wrap']
      this.itemIndex++
      let num = item.week.slice(1)
      return {
        transform: `translateX(${num / 52 * (t.clientWidth - 100)}px)`
      }
    },
    getBeginLists () {
      let newLists = []
      newLists = this.lists.map((item, index) => {
        item.style = this.getIndex(item)
        return item
      })
      return newLists
    }

  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.task-progress-wrap
  height: 300px
  display: flex
  align-items: center
  width 100%
.progress-bar
  position: relative;
  width 100%
  .triangle
    clip-path:polygon(0% 35%, 97% 35%, 97% 0%,100% 50%,97% 100%,97% 65%,0% 65%)
    background-color rgba(209,209,209,1)
    display: inline-block
    width 100%
    height 50px
  .time
    position: absolute;
    right: 0;
    top: -70%;
    font-weight: bolder;
    font-size: 22px
  .daily-log-wrap
    .item
      position: absolute
      top: -200%;

      .content
        font-weight: bolder
      .icon-line
        position: absolute
        width 1px
        height 60px
        background-color: #999
        margin: auto
        left: 0
        right: 0
      .txt
        white-space: nowrap
        .task-name
          margin-bottom: 10px
          width 100px
          text-align: center
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
    .finish
      top: 100%

.item
  .icon-line
    .line-time
      position: absolute
      bottom: 0
      transform: translateX(-130%)
.finish
  .txt
    position: relative
    top: 64px
  .icon-line
    .line-time
      position: absolute
      top: 0
      transform: translateX(-130%)

.item.item1
  transform: translateX(60px)
.item.item2
  transform: translateX(460px)

.finish.item3
  transform: translateX(860px)
</style>
